import type { ProductColor } from '@aloft/toolkit-shared';
import type { BlockProps } from '@aloft/toolkit-sui';
import { Block, Flex } from '@aloft/toolkit-sui';

import { clsx } from 'clsx';

import { getReferenceProperty } from '../../../modules/utils/getReferenceProperty.ts';
import type { AivArvActiveTab } from '../../../redux/types.ts';
import { registerTkv2ReferenceProperty } from '../../ReferenceBar/registerTkv2ReferenceProperty.ts';

type ColumnSectionProps = {
  className: string;
  compSequence: string[];
  renderForId: ({ id }: { id: string }) => React.ReactNode;
  backgroundColor?: ProductColor;
  contentFill?: boolean;
  noTopBorder?: boolean;
  aivArvTab?: AivArvActiveTab;
};

export const ColumnSection = ({
  compSequence,
  className,
  renderForId: RenderForID,
  backgroundColor = 'surface1',
  contentFill = false,
  noTopBorder = false,
  aivArvTab,
}: ColumnSectionProps) => {
  const classes = [className, 'grid-area'];
  const referenceBar = (col: string) =>
    registerTkv2ReferenceProperty(getReferenceProperty(col, compSequence));

  const columnStyles: BlockProps = {
    backgroundColor,
    borderStyle: 'solid',
    borderColor: 'strokeLight',
    borderTopWidth: noTopBorder ? '0' : '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    minWidth: 'max-content',
    width: '100%',
  };

  const paddingX = contentFill ? '0' : '1rem';

  return (
    <>
      <Block
        className={clsx([...classes, 'subject-cell'])}
        {...referenceBar('subject')}
        {...columnStyles}
      >
        {aivArvTab === 'all' && (
          <Flex>
            <Block
              paddingX={paddingX}
              minWidth="260px"
              borderRightWidth="1px"
              borderColor="strokeDefault"
              borderStyle="solid"
            >
              <RenderForID id="subject" />
            </Block>
            <Block paddingX={paddingX} minWidth="260px">
              <RenderForID id="subjectArv" />
            </Block>
          </Flex>
        )}
        {aivArvTab === 'aiv' && (
          <Block paddingX={paddingX}>
            <RenderForID id="subject" />
          </Block>
        )}
        {aivArvTab === 'arv' && (
          <Block paddingX={paddingX} minWidth="260px">
            <RenderForID id="subjectArv" />
          </Block>
        )}
        {!aivArvTab && (
          <Block paddingX={paddingX}>
            <RenderForID id="subject" />
          </Block>
        )}
      </Block>
      {compSequence.map((compID) => (
        <Block
          key={`${className}-${compID}`}
          className={clsx(classes)}
          {...referenceBar(compID)}
          {...columnStyles}
        >
          <Block paddingX={paddingX} height="100%">
            <RenderForID id={compID} />
          </Block>
        </Block>
      ))}
    </>
  );
};
